import { render, staticRenderFns } from "./ServicesProvidedByDoctor.vue?vue&type=template&id=5a9e115f&scoped=true"
import script from "./ServicesProvidedByDoctor.vue?vue&type=script&lang=js"
export * from "./ServicesProvidedByDoctor.vue?vue&type=script&lang=js"
import style0 from "./ServicesProvidedByDoctor.vue?vue&type=style&index=0&id=5a9e115f&prod&scoped=true&lang=css"
import style1 from "./ServicesProvidedByDoctor.vue?vue&type=style&index=1&id=5a9e115f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9e115f",
  null
  
)

export default component.exports